import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import { setAuth } from '../../containers/client/actions';
import { stockDetailRequest } from '../modal/stockDetail/actions';
import { WebSocketContext } from '../../containers/socket/webSocket';
import {
  makeGetToken,
  makeGetListOrder,
  makeGetMatchOrder,
  makeGetAuth,
  makeGetAllOrder,
} from '../../lib/selector';

import PerfectScrollBar from 'react-perfect-scrollbar';
import { Col, Button } from 'react-bootstrap';

import {
  canDeleteOrder,
  canEditOrder,
  numberFormat,
  _convertTpToPrice,
  _getOrderStatus,
} from '../../utils';

import { find, sum, map, filter } from 'lodash';
import { FaPen, FaTimesCircle } from 'react-icons/fa';

import FormEditOrder from '../modal/order/editOrder';
import FormDeleteOrder from '../modal/order/deleteOrder';
import { v4 as uuidv4 } from 'uuid';
import { allOrdRequest } from '../../containers/banggia/actions';
import { ReloadButton } from '../btnReload';
import PaginationTable from '../PaginationTable';
import {
  cancelOrderRequest,
  editOrderRequest,
  matchOrderRequest,
  symbolInfoRequest,
} from '../../containers/privData/actions';
import { translate } from 'react-i18next';
class LenhThuong extends React.PureComponent {
  state = {
    _nextKey: '1',

    listOrder: [],
    ordSel: null,
    order: null,
    showModal: false,
    showModalDel: false,
  };

  componentDidMount() {
    const { account } = this.props;
    if (account) this._handleLoadAllOrderInday();
  }

  _handleLoadAllOrderInday = () => {
    const { account, token } = this.props;
    if (!account || !token) return;

    const uuid = uuidv4();
    const params = {
      group: 'CORE',
      cmd: 'getAllOrderList',
      user: token.user,
      session: token.session,
      rqId: uuid,
      channel: 'WTS',
      data: {
        custNo: account.acntNo,
      },
    };

    this.props.dispatch(allOrdRequest(params));
  };

  componentDidUpdate(preProps) {
    const { account, listOrder } = this.props;
    // const { _nextKey } = this.state;

    if (account && account !== preProps.account) {
      this.setState({ ordSel: null });
      this._handleLoadAllOrderInday();
    }

    if (listOrder && listOrder !== preProps.listOrder) {
      console.log('listOrder', listOrder);
      const _allOrder = filter(
        listOrder.list,
        ({ subAcntNo }) => account.subAcntNo === subAcntNo
      );
      this.setState({ listOrder: [..._allOrder] });
      // if (_nextKey === '1') {
      //   this.setState({ listOrder: listOrder.list });
      // } else {
      //   this.setState({
      //     listOrder: [...this.state.listOrder, ...listOrder.list],
      //   });
      // }
    }
  }

  _handleOrderDetail = (record) => {
    if (!record || !record.ordrNo) return;
    // let ws = this.context;
    const { token, account } = this.props;
    // const { listOrder } = this.state;
    if (account) {
      const uuid = uuidv4();

      const resData = {
        group: 'CORE',
        cmd: 'GetMatchOrder',
        user: token.user,
        session: token.session,
        rqId: uuid,
        channel: 'WTS',
        data: {
          acntNo: account.acntNo,
          subAcntNo: account.subAcntNo,
          ordrNo: record.ordrNo + '',
        },
      };
      this.props.dispatch(matchOrderRequest(resData));
    }

    // const ordSel = find(listOrder, (o) => o.ordrNo === record.ordrNo);
    this.setState({ ordSel: record });
  };

  _handleAuthen = () => {
    this.props.dispatch(setAuth());
  };

  _handleDeleteOrder = (orderNo) => {
    console.log(orderNo);
    const { listOrder } = this.props;

    const order = find(listOrder.list, (o) => o.ordrNo === orderNo);
    if (order) {
      console.log(order);
      this.props.dispatch(stockDetailRequest(order.symbol));
      this.setState({ showModalDel: true, order });
    }
  };

  _handleEditOrder = (orderNo) => {
    const { listOrder } = this.props;

    const order = find(listOrder.list, (o) => o.ordrNo === orderNo);
    if (order) {
      console.log(order);
      this._handleLoadSymbolInfo(order.symbol);
      this.props.dispatch(stockDetailRequest(order.symbol));
      this.setState({ showModal: true, order });
    }
  };

  _handleLoadSymbolInfo = (symbol) => {
    // let ws = this.context;
    const { account, token } = this.props;

    if (account) {
      const uuid = uuidv4();

      const params = {
        group: 'CORE',
        user: token.user,
        session: token.session,
        cmd: 'getSymbolInfo',
        rqId: uuid,
        channel: 'WTS',
        data: {
          acntNo: account.acntNo,
          subAcntNo: account.subAcntNo,
          symbol: symbol,
        },
      };
      this.props.dispatch(symbolInfoRequest(params));
    }
  };

  _handleSubmitEditOrder = (params) => {
    this.props.dispatch(editOrderRequest(params));
    // let ws = this.context;
    this.setState({ showModal: false, order: null });
  };

  _handleSubmitDeleteOrder = (params) => {
    this.props.dispatch(cancelOrderRequest(params));
    // let ws = this.context;
    this.setState({ showModalDel: false, order: null });
  };

  _handleCloseModal = () => {
    this.setState({ showModal: false, order: null });
  };

  _handleCloseModalDel = () => {
    this.setState({ showModalDel: false, order: null });
  };

  render() {
    const { account, matchOrder, auth, t } = this.props;
    const { listOrder, ordSel, order, showModal, showModalDel } = this.state;
    // console.log('account', account);
    // console.log('matchOrder', matchOrder);
    // console.log('ordSel', ordSel);
    const listOrderToShow = !listOrder
      ? []
      : filter(listOrder, (o) => o.modiCnclTp !== '3');

    const _sumPrice = !ordSel
      ? 0
      : ordSel.buySelTp === '1'
      ? matchOrder && !!matchOrder.list
        ? sum(map(matchOrder.list, (o) => o.matchQty * o.matchPrc + o.feeAmt))
        : 0
      : matchOrder && !!matchOrder.list
      ? sum(
          map(
            matchOrder.list,
            (o) => o.matchQty * o.matchPrc * 0.999 - o.feeAmt
          )
        )
      : 0;
    const _sumVol =
      matchOrder && !!matchOrder.list
        ? sum(map(matchOrder.list, (o) => o.matchQty))
        : 0;

    const columns = [
      {
        key: 'ordrNo',
        text: t('txt-order-no'),
        className: 'text-center',
        align: 'center',
      },
      {
        key: 'origOrdrNo',
        text: t('txt-origin-order-no'),
        className: 'text-center',
        align: 'center',
      },
      {
        key: 'wrkTime',
        text: t('txt-time'),
        className: 'text-center',
        align: 'center',
        cell: (record) => {
          return record.wrkTime
            ? record.wrkTime.split(' ').length > 1
              ? record.wrkTime.split(' ')[1]
              : record.wrkTime.split(' ')
            : '';
        },
      },
      {
        key: 'buySelTp',
        text: t('txt-trade-acronym'),
        className: 'text-center w_75',
        align: 'center',
        cell: (record) => {
          return (
            <div
              className={'text-uppercase mx-auto trade_side_' + record.buySelTp}
            >
              {record.buySelTp === '1' ? t('txt-buy') : t('txt-sell')}
            </div>
          );
        },
      },
      {
        key: 'symbol',
        text: t('txt-symbol'),
        className: 'text-center',
        align: 'center',
      },
      {
        key: 'ordrTrdTp',
        text: t('txt-type'),
        className: 'text-center',
        align: 'center',
        cell: (record) => {
          return _convertTpToPrice(record.ordrTrdTp);
        },
      },
      {
        key: 'ordrUntprc',
        text: t('txt-price'),
        className: 'text-right',
        align: 'center',
        cell: (record) => {
          return numberFormat(record.ordrUntprc);
        },
      },
      {
        key: 'ordrQty',
        text: t('txt-vol'),
        className: 'text-right',
        align: 'center',
        cell: (record) => {
          return numberFormat(record.ordrQty);
        },
      },
      {
        key: 'matchedQty',
        text: t('txt-match-vol'),
        className: 'text-right',
        align: 'center',
        cell: (record) => {
          return numberFormat(record.matchedQty, 0, '0');
        },
      },
      {
        key: 'ordrStatTp',
        text: t('txt-status'),
        className: (record) => {
          return 'text-center ordStt_' + record.ordrStatTp;
        },
        align: 'center',
        cell: (record) => {
          return _getOrderStatus(
            record.ordrStatTp,
            record.ordrQty,
            record.matchedQty
          );
        },
      },
    ];

    return (
      <Fragment>
        <PerfectScrollBar style={{ height: 'calc( 100% - 50px )' }}>
          <div className="d-flex flex-row">
            <Col className="d-flex flex-column pr-0">
              <div className="d-flex flex-row mt-3 mb-2">
                <span className="text-white fz-18">
                  {`${t('txt-order-normal')}:`}
                </span>
                &nbsp;
                <span className="mr-auto font-weight-bold text-white fz-18">
                  {account &&
                    account.value +
                      ' - ' +
                      (account.value.startsWith('M')
                        ? 'Margin'
                        : t('txt-normal'))}
                </span>
                <ReloadButton
                  type="button"
                  className="mr-3 btn-reload"
                  onClick={() => this._handleLoadAllOrderInday()}
                />
              </div>
              <PaginationTable
                tblClassName="tbl-list"
                divClassName="mt-2"
                onRowClicked={this._handleOrderDetail}
                pageSize={15}
                columns={columns}
                source={listOrderToShow ? listOrderToShow : []}
              />
            </Col>
            <Col className="d-flex flex-column">
              {ordSel && (
                <Fragment>
                  <div className="d-flex align-items-center flex-row mt-3 mb-2">
                    <span className="text-white fz-18">{ordSel.symbol}</span>
                    &nbsp;
                    <div
                      className={
                        'fz-18 text-uppercase trade_side_' + ordSel.buySelTp
                      }
                    >
                      {ordSel.buySelTp === '1' ? t('txt-buy') : t('txt-sell')}
                    </div>
                    <span
                      className={
                        'fz-18 pl-2 mr-auto ordStt_' + ordSel.ordrStatTp
                      }
                    >
                      {_getOrderStatus(
                        ordSel.ordrStatTp,
                        ordSel.ordrQty,
                        ordSel.matchedQty
                      )}
                    </span>
                    <div>
                      {auth && auth.isVerified ? (
                        <Fragment>
                          {!canDeleteOrder(
                            ordSel.ordrStatTp,
                            ordSel.ordrQty,
                            ordSel.matchedQty
                          ) ? (
                            <label className="text-muted d-inline-block fz-14">
                              <FaTimesCircle
                                style={{
                                  paddingRight: '2px',
                                  marginRight: '2px',
                                }}
                              />
                              {t('txt-label-order-del')}
                            </label>
                          ) : (
                            <label
                              className="d d-inline-block fz-14"
                              onClick={() =>
                                this._handleDeleteOrder(ordSel.ordrNo)
                              }
                            >
                              <FaTimesCircle
                                style={{
                                  paddingRight: '2px',
                                  marginRight: '2px',
                                }}
                              />
                              {t('txt-label-order-del')}
                            </label>
                          )}
                          {!canEditOrder(
                            ordSel.ordrStatTp,
                            ordSel.ordrQty,
                            ordSel.matchedQty,
                            ordSel.ordrTrdTp
                          ) ? (
                            <label className="text-muted d-inline-block fz-14 ml-4">
                              <FaPen
                                style={{
                                  paddingRight: '2px',
                                  marginRight: '2px',
                                }}
                              />
                              {t('txt-label-order-edit')}
                            </label>
                          ) : (
                            <label
                              className="f d-inline-block fz-14 ml-4"
                              onClick={() =>
                                this._handleEditOrder(ordSel.ordrNo)
                              }
                            >
                              <FaPen
                                style={{
                                  paddingRight: '2px',
                                  marginRight: '2px',
                                }}
                              />
                              {t('txt-label-order-edit')}
                            </label>
                          )}
                        </Fragment>
                      ) : (
                        <Button
                          variant="warning"
                          className="fz-14"
                          style={{ height: '22px', padding: '0 15px' }}
                          onClick={() => this._handleAuthen()}
                        >
                          {t('txt-xacthuc')}
                        </Button>
                      )}
                    </div>
                  </div>
                  <table className="table table-bordered tbl-detail mt-2">
                    <thead>
                      <tr className="tbl-detail-head">
                        <th className="text-left">
                          <span>{t('txt-order-no')}</span>
                          <span className="float-right font-weight-bold">
                            {ordSel && ordSel.ordrNo}
                          </span>
                        </th>
                        <th></th>
                        <th className="text-left">
                          <span>{t('txt-total-vol')}</span>
                          <span className="float-right font-weight-bold">
                            {numberFormat(_sumVol, 0, '0')}
                          </span>
                        </th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th className="text-left">
                          <span>{t('txt-total-val')}</span>
                          <span className="float-right font-weight-bold">
                            {numberFormat(_sumPrice, 0, '0')}
                          </span>
                        </th>
                      </tr>
                      <tr>
                        <th className="text-center">{t('txt-time')}</th>
                        <th className="text-center">{t('txt-match-price')}</th>
                        <th className="text-center">{t('txt-match-vol')}</th>
                        <th className="text-center">
                          {t('txt-label-total-amount')}
                        </th>
                        <th className="text-center">
                          {t('txt-label-trading-fee')}
                        </th>
                        <th className="text-center">{t('txt-label-tax')}</th>
                        <th className="text-center">
                          {t('txt-label-real-amount')}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {matchOrder &&
                        matchOrder.list &&
                        !!matchOrder.list.length &&
                        matchOrder.list.map((item, i) => (
                          <tr key={i}>
                            <td className="text-center">
                              {item.matchTime && item.matchTime.split(' ')[1]}
                            </td>
                            <td className="text-right">
                              {numberFormat(item.matchPrc, 0, '0')}
                            </td>
                            <td className="text-right">
                              {numberFormat(item.matchQty, 0, '0')}
                            </td>
                            <td className="text-right">
                              {numberFormat(
                                item.matchQty * item.matchPrc,
                                0,
                                '0'
                              )}
                            </td>
                            <td className="text-right">
                              {numberFormat(item.feeAmt, 0, '0')}
                            </td>
                            <td className="text-right">
                              {ordSel.buySelTp === '1'
                                ? '0'
                                : numberFormat(
                                    item.matchQty * item.matchPrc * 0.001,
                                    0,
                                    '0'
                                  )}
                            </td>
                            <td className="text-right">
                              {ordSel.buySelTp === '1'
                                ? numberFormat(
                                    item.matchQty * item.matchPrc + item.feeAmt,
                                    0,
                                    '0'
                                  )
                                : numberFormat(
                                    item.matchQty * item.matchPrc * 0.999 -
                                      item.feeAmt,
                                    0,
                                    '0'
                                  )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  {(!matchOrder ||
                    !matchOrder.list ||
                    !matchOrder.list.length) && (
                    <p className="text-center fz-14 mt-2 title-time">
                      {t('txt-no-data-found')}
                    </p>
                  )}
                </Fragment>
              )}
            </Col>
          </div>
          <div className=""></div>
        </PerfectScrollBar>
        {showModal && (
          <FormEditOrder
            order={order}
            showModal={showModal}
            handleCloseModal={this._handleCloseModal}
            handleSubmitOrder={this._handleSubmitEditOrder}
          />
        )}
        {showModalDel && (
          <FormDeleteOrder
            order={order}
            showModal={showModalDel}
            handleCloseModal={this._handleCloseModalDel}
            handleSubmitOrder={this._handleSubmitDeleteOrder}
          />
        )}
      </Fragment>
    );
  }
}

LenhThuong.contextType = WebSocketContext;

const makeMapStateToProps = () => {
  const getToken = makeGetToken();
  const getAuth = makeGetAuth();
  // const getListOrder = makeGetListOrder();
  const getAllOrder = makeGetAllOrder();
  const getMatchOrder = makeGetMatchOrder();

  const mapStateToProps = (state, props) => {
    return {
      token: getToken(state),
      auth: getAuth(state),
      listOrder: getAllOrder(state),
      matchOrder: getMatchOrder(state),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(
  translate('translations')(LenhThuong)
);
